import _ from 'underscore';
import React from 'react';
import { util } from '@bingads-webui-campaign/report-shared';
import InlineEditDateRange from '../actions/inline-edit/date-range';

function getDateRange({ item, i18n }) {
  const dataRange = _.get(item, ['ReportTime']) || _.get(item, ['Selection', 'DateRange']);
  return util.formatDateRange(i18n, dataRange, item.ReportTimeZone);
}

export default ({
  i18n, handleInlineEditSuccess, legacyI18n, notifyErrorPipe,
}) => ({
  key: 'date-range',
  name: i18n.getString(_TL_('Date range')),
  fieldName: 'ReportTime/DateRangePreset',
  minWidth: 250,
  maxWidth: 300,
  isResizable: true,
  sortable: true,
  data: 'number',
  onRender: item => getDateRange({ item, i18n }),
  inlineEdit: true,
  onRenderInlineEdit: (e, item, hanelDismiss, cell, selector) => (
    <InlineEditDateRange
      item={item}
      target={selector}
      legacyI18n={legacyI18n}
      onDismiss={() => hanelDismiss()}
      onActionSuccess={() => handleInlineEditSuccess()}
      notifyErrorPipe={notifyErrorPipe}
    />
  ),
});
